import { createFileRoute, redirect, useSearch } from "@tanstack/react-router";
import { getDefaultStore } from "jotai";
import { z } from "zod";

import { RecurrenceSuccess } from "@/components/recurring-appointment/recurrence-success";
import { Page } from "@/components/ui/layout/page/page";
import { RoundedLayout } from "@/components/ui/layout/rounded-layout";
import {
  recurringSessionsAtom,
  recurringSlotAtom,
} from "@/lib/atoms/recurring-appointment-form-atom";

import type { JSX } from "react";

const RecurringAppointmentSuccessPage = (): JSX.Element => {
  const { naoAgendadas } = useSearch({
    from: "/recurring-appointments/create/success",
  });

  const skippedDates = naoAgendadas ? naoAgendadas.split(",").filter(Boolean) : [];

  return (
    <RoundedLayout>
      <Page>
        <RecurrenceSuccess naoAgendadas={skippedDates} />
      </Page>
    </RoundedLayout>
  );
};

export const Route = createFileRoute("/recurring-appointments/create/success")({
  component: RecurringAppointmentSuccessPage,
  validateSearch: z.object({ naoAgendadas: z.string().optional() }),
  beforeLoad: () => {
    const store = getDefaultStore();
    const slot = store.get(recurringSlotAtom);
    const sessions = store.get(recurringSessionsAtom);

    if (!slot.horaInicio || sessions.length === 0) {
      redirect({ to: "/recurring-appointments/create", throw: true });
    }
  },
});
